import { DateTime } from 'luxon'
import _identity from 'lodash/identity'

export const PROFILE_PROPERTY_CONVERTERS = {
  advertisingId: _identity,
  autoRedeemSharesEnabled: _identity,
  dateOfBirth: (value) => DateTime.fromISO(value).toFormat('yyyy-MM-dd'),
  email: _identity,
  gender: _identity,
  phoneNumber: _identity,
  postalCode: _identity,
  region: _identity,
  termsAndConditions: _identity,
}
